import { useState } from "react";

import "./BusinessInfo.css";

import BusinessInfoCommon from "./BusinessInfoCommon";

const storeCategories = [
    "Groceries",
    "Fruits",
    "Vegetables",
    "Milk & Dairy",
    "Bakery Products",
    "Rice & Grains",
    "Oil & Ghee",
    "Beverages",
    "Snacks",
    "Frozen Foods",
    "Household Items",
    "Personal Care",
];

const provisionServices = [
    "Home Delivery",
    "Store Pickup",
    "Same Day Delivery",
    "Express Delivery",
    "Cash on Delivery",
    "Bulk Orders",
];

function ProvisionBusinessInfo({

    providerData,

    setProviderData,

    nextStep,

    previousStep,

}) {

    const business = providerData.business || {};

    const [errors, setErrors] = useState({});

    const [showDeclaration, setShowDeclaration] =
        useState(false);

    const [acceptedDeclaration, setAcceptedDeclaration] =
        useState(false);

    const hours = [
        "01","02","03","04","05","06",
        "07","08","09","10","11","12",
    ];

    const minutes = [
        "00","05","10","15","20","25",
        "30","35","40","45","50","55",
    ];

    const meridians = [
        "AM",
        "PM",
    ];

    // =====================================
    // Handle Change
    // =====================================

    const handleChange = (e) => {

        const {

            name,

            value,

        } = e.target;

        setProviderData({

            ...providerData,

            business: {

                ...business,

                [name]: value,

            },

        });

    };

    // =====================================
    // Toggle Store Category
    // =====================================

    const toggleCategory = (category) => {

        const list =
            business.categories || [];

        if (list.includes(category)) {

            setProviderData({

                ...providerData,

                business: {

                    ...business,

                    categories: list.filter(

                        item => item !== category

                    ),

                },

            });

        }

        else {

            setProviderData({

                ...providerData,

                business: {

                    ...business,

                    categories: [

                        ...list,

                        category,

                    ],

                },

            });

        }

    };

    // =====================================
    // Toggle Service
    // =====================================

    const toggleService = (service) => {

        const list =
            business.services || [];

        if (list.includes(service)) {

            setProviderData({

                ...providerData,

                business: {

                    ...business,

                    services: list.filter(

                        item => item !== service

                    ),

                },

            });

        }

        else {

            setProviderData({

                ...providerData,

                business: {

                    ...business,

                    services: [

                        ...list,

                        service,

                    ],

                },

            });

        }

    };
        // =====================================
    // Validation
    // =====================================

    const validate = () => {

        let newErrors = {};

        if (!business.businessName?.trim()) {
            newErrors.businessName =
                "Business Name is required";
        }

        if (!business.description?.trim()) {
            newErrors.description =
                "Business Description is required";
        }

        if (
            !business.openingHour ||
            !business.openingMinute ||
            !business.openingPeriod
        ) {
            newErrors.openingTime =
                "Opening Time is required";
        }

        if (
            !business.closingHour ||
            !business.closingMinute ||
            !business.closingPeriod
        ) {
            newErrors.closingTime =
                "Closing Time is required";
        }

        if (!business.deliveryRadius) {
            newErrors.deliveryRadius =
                "Delivery Radius is required";
        }

        if (!business.hasGST) {
            newErrors.hasGST =
                "Please select GST option";
        }

        if (!business.hasFSSAI) {
            newErrors.hasFSSAI =
                "Please select FSSAI option";
        }

        if (
            business.hasGST === "Yes" &&
            !business.gstNumber?.trim()
        ) {
            newErrors.gstNumber =
                "GST Number is required";
        }

        if (
            business.hasFSSAI === "Yes" &&
            !business.fssaiNumber?.trim()
        ) {
            newErrors.fssaiNumber =
                "FSSAI Number is required";
        }

        if (
            !business.categories ||
            business.categories.length === 0
        ) {
            newErrors.categories =
                "Select at least one Store Category";
        }

        if (
            !business.services ||
            business.services.length === 0
        ) {
            newErrors.services =
                "Select at least one Service";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;

    };

    // =====================================
    // Continue
    // =====================================

    const handleContinue = () => {

        if (!validate()) return;

        if (
            business.hasGST === "No" ||
            business.hasFSSAI === "No"
        ) {

            setShowDeclaration(true);

            return;

        }

        nextStep();

    };

    // =====================================
    // Declaration Continue
    // =====================================

    const handleDeclarationContinue = () => {

        if (!acceptedDeclaration) {

            alert(
                "Please accept the declaration."
            );

            return;

        }

        setShowDeclaration(false);

        nextStep();

    };

    // =====================================
    // Close Declaration
    // =====================================

    const closeDeclaration = () => {

        setShowDeclaration(false);

        setAcceptedDeclaration(false);

    };

    // =====================================
    // JSX Starts
    // =====================================

    return (

        <div className="business-info-step">

            <BusinessInfoCommon

                business={business}

                errors={errors}

                handleChange={handleChange}

                hours={hours}

                minutes={minutes}

                meridians={meridians}

            />
                        {/* =========================
                GST Registration
            ========================= */}

            <label>Do you have GST Registration?</label>

            <div className="radio-group">

                <label>
                    <input
                        type="radio"
                        name="hasGST"
                        value="Yes"
                        checked={business.hasGST === "Yes"}
                        onChange={handleChange}
                    />
                    Yes
                </label>

                <label>
                    <input
                        type="radio"
                        name="hasGST"
                        value="No"
                        checked={business.hasGST === "No"}
                        onChange={handleChange}
                    />
                    No
                </label>

            </div>

            {errors.hasGST && (
                <span className="error">
                    {errors.hasGST}
                </span>
            )}

            {business.hasGST === "Yes" && (

                <input
                    type="text"
                    name="gstNumber"
                    placeholder="GST Registration Number"
                    value={business.gstNumber || ""}
                    onChange={handleChange}
                />

            )}

            {errors.gstNumber && (
                <span className="error">
                    {errors.gstNumber}
                </span>
            )}

            {/* =========================
                FSSAI Registration
            ========================= */}

            <label>Do you have FSSAI Registration?</label>

            <div className="radio-group">

                <label>
                    <input
                        type="radio"
                        name="hasFSSAI"
                        value="Yes"
                        checked={business.hasFSSAI === "Yes"}
                        onChange={handleChange}
                    />
                    Yes
                </label>

                <label>
                    <input
                        type="radio"
                        name="hasFSSAI"
                        value="No"
                        checked={business.hasFSSAI === "No"}
                        onChange={handleChange}
                    />
                    No
                </label>

            </div>

            {errors.hasFSSAI && (
                <span className="error">
                    {errors.hasFSSAI}
                </span>
            )}

            {business.hasFSSAI === "Yes" && (

                <input
                    type="text"
                    name="fssaiNumber"
                    placeholder="FSSAI Registration Number"
                    value={business.fssaiNumber || ""}
                    onChange={handleChange}
                />

            )}

            {errors.fssaiNumber && (
                <span className="error">
                    {errors.fssaiNumber}
                </span>
            )}

            {/* =========================
                Delivery Radius
            ========================= */}

            <input
                type="number"
                name="deliveryRadius"
                placeholder="Delivery Radius (KM)"
                value={business.deliveryRadius || ""}
                onChange={handleChange}
            />

            {errors.deliveryRadius && (
                <span className="error">
                    {errors.deliveryRadius}
                </span>
            )}

            {/* =========================
                Average Order Value
            ========================= */}

            <input
                type="text"
                name="priceRange"
                placeholder="Average Order Value (₹100 - ₹1000)"
                value={business.priceRange || ""}
                onChange={handleChange}
            />

            {/* =========================
                Weekly Holiday
            ========================= */}

            <label>Weekly Holiday</label>

            <select
                name="weeklyHoliday"
                value={business.weeklyHoliday || ""}
                onChange={handleChange}
            >

                <option value="">
                    Select Day
                </option>

                <option>Monday</option>
                <option>Tuesday</option>
                <option>Wednesday</option>
                <option>Thursday</option>
                <option>Friday</option>
                <option>Saturday</option>
                <option>Sunday</option>
                <option>No Weekly Holiday</option>

            </select>

            {/* =========================
                Store Categories
            ========================= */}

            <h3>Store Categories</h3>

            <div className="selection-grid">

                {storeCategories.map((item) => (

                    <div
                        key={item}
                        className={`select-box ${
                            business.categories?.includes(item)
                                ? "active"
                                : ""
                        }`}
                        onClick={() => toggleCategory(item)}
                    >

                        {item}

                    </div>

                ))}

            </div>

            {errors.categories && (
                <span className="error">
                    {errors.categories}
                </span>
            )}

            {/* =========================
                Services Offered
            ========================= */}

            <h3>Services Offered</h3>

            <div className="selection-grid">

                {provisionServices.map((item) => (

                    <div
                        key={item}
                        className={`select-box ${
                            business.services?.includes(item)
                                ? "active"
                                : ""
                        }`}
                        onClick={() => toggleService(item)}
                    >

                        {item}

                    </div>

                ))}

            </div>

            {errors.services && (
                <span className="error">
                    {errors.services}
                </span>
            )}
                        {/* =========================
                Declaration Popup
            ========================= */}

            {showDeclaration && (

                <div className="declaration-overlay">

                    <div className="declaration-popup">

                        <h2>
                            Declaration for Provision Store
                        </h2>

                        <p>
                            Since you selected <b>No</b> for GST or FSSAI,
                            please read and accept the declaration below.
                        </p>

                        <div className="declaration-text">

                            <p>
                                ✔ I confirm that all information provided is true and accurate.
                            </p>

                            <p>
                                ✔ I understand that obtaining GST, FSSAI and any other licences required by law is my responsibility.
                            </p>

                            <p>
                                ✔ I understand that I must comply with all Government regulations, taxation laws and local authority requirements.
                            </p>

                            <p>
                                ✔ HomeFoods is only a technology platform connecting customers with provision stores.
                            </p>

                            <p>
                                ✔ HomeFoods is not responsible for my GST, FSSAI, licences, permits or statutory obligations.
                            </p>

                            <p>
                                ✔ HomeFoods may request additional documents for verification at any time.
                            </p>

                            <p>
                                ✔ Providing false information may result in account suspension or permanent removal.
                            </p>

                            <p>
                                ✔ I am fully responsible for product quality, storage, expiry dates, packaging, hygiene and customer safety.
                            </p>

                        </div>

                        <label className="agree-checkbox">

                            <input
                                type="checkbox"
                                checked={acceptedDeclaration}
                                onChange={(e) =>
                                    setAcceptedDeclaration(
                                        e.target.checked
                                    )
                                }
                            />

                            I have read and agree to the above declaration.

                        </label>

                        <div className="popup-buttons">

                            <button
                                type="button"
                                onClick={closeDeclaration}
                            >
                                Cancel
                            </button>

                            <button
                                type="button"
                                disabled={!acceptedDeclaration}
                                onClick={handleDeclarationContinue}
                            >
                                Continue
                            </button>

                        </div>

                    </div>

                </div>

            )}

            {/* =========================
                Navigation Buttons
            ========================= */}

            <div className="step-buttons">

                <button
                    type="button"
                    onClick={previousStep}
                >
                    ← Back
                </button>

                <button
                    type="button"
                    onClick={handleContinue}
                >
                    Continue →
                </button>

            </div>

        </div>

    );

}

export default ProvisionBusinessInfo;